"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AutoComplete_1 = require("./../AutoComplete");
var countryApiService_1 = require("./countryApiService");
var CountryAutoComplete = (function (_super) {
    __extends(CountryAutoComplete, _super);
    function CountryAutoComplete(props) {
        var _this = _super.call(this, props) || this;
        AutoComplete_1.default.cachedItems[_this.props.name] = [];
        return _this;
    }
    CountryAutoComplete.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method-countryAutoComplete-dropdown" },
            React.createElement(AutoComplete_1.default, __assign({ fetchItems: countryApiService_1.default.fetchCountries }, this.props))));
    };
    return CountryAutoComplete;
}(React.Component));
exports.default = CountryAutoComplete;
//# sourceMappingURL=CountryAutoComplete.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/CountryAutoComplete/CountryAutoComplete.js
// module id = 196
// module chunks = 0 1